module.exports = {"version":"1.2.20171120","verInfo":"1.2.0","testdate":"2017112015","api":"/web","upload":"/ImageApi.php","download":"/downLoad.php","checkTimer":60,"thirdUrl":"http://localhost:6680"}


//////////////////
// WEBPACK FOOTER
// ./src/lib/util/config.json
// module id = 1053
// module chunks = 105